export const getUrlParams = (urlSearchString) => Object.fromEntries(
  new URLSearchParams(urlSearchString),
);
